import React from 'react';
import { Progress, message } from 'antd';
import { connect } from 'react-redux';
import loadingGif from '../../resource/img/loading/loading-web.gif';
import mscratchService from '../../services/mscratch';
import ProjectAction from '../../reducers/project/action';
import './loading.web.less';
import Subscribe from '../../util/subscribe';

const allPercentRange = 100;
const downPercentRange = 95; // 下载总进度
const mscratchPercentRange = 5; // mscratch 加载进度

class Loading extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            percent: 0,
        };
        this.init();
    }

    componentDidMount() {
        let that = this;
        this.mounted = true;
        mscratchService.project.onProcess((value) => {
            if (that.mounted) {
                value = downPercentRange + mscratchPercentRange / allPercentRange * (value.complete / value.total * allPercentRange);
                that.updatePercent(value);
            }
        });
    }

    init = () => {
        Subscribe.listen('file_download', (value) => {
            console.log('receive file download percent ', value);
            let percentRange = downPercentRange;
            value = percentRange / allPercentRange * value;
            this.updatePercent(value);
            value === allPercentRange && Subscribe.remove('file_download');
        });
        Subscribe.listen('file_download_error', () => {
            this.props.hideLoadingPage();
            const { messages } = this.props.intlr;
            message.error(messages['UPDATER.PROGRESS.ERROR']);
            Subscribe.remove('file_download_error');
        });
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    updatePercent(value) {        
        const percent = parseInt(value) > allPercentRange ? allPercentRange : parseInt(value);
        this.setState({
            percent
        });
        if (percent == allPercentRange) {
            this.props.hideLoadingPage();
        }
    }

    render() {
        const { messages } = this.props.intlr;
        const { percent } = this.state;
        return (
            <div className="loading-page-wrapper">
                <div className="loading-page">
                    <img className="gif" src={loadingGif}/>
                    <p className="tip">{messages['PROJECT.LOADING_TIP']}</p>
                    <Progress className="progress-bar" percent={percent}
                        showInfo={false}
                        strokecolor="#46B5FF"
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    intlr: state.intlr,
    project: state.project
});

const mapDispatchToProps = dispatch => ({
    hideLoadingPage: () => dispatch(ProjectAction.saved({
        showLoadingPage: false
    }))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Loading);